import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { refreshToken } from '../services/Auth/auth';

const useUserStore = create(
    persist(
        (set, get) => ({
            memberTokens: '',
            userInfo: {},
            isExq: false,
            refreshingToken: false,
            isSnsLogin: false,
            joinVerificationInfo: {
                ci: '',
                di: '',
                username: '',
                mem_phone: '',
                gender: '',
                birthdate: '',
                memberKind: ''
            },
            updateJoinVerificationInfo: (info) => set((state) => ({
                joinVerificationInfo: {
                    ...state.joinVerificationInfo,
                    ...info
                }
            })),
            updateSnsLogin: (isSns) => set({isSnsLogin: isSns}),
            updateTokens: (token) => set({ memberTokens: token }),
            updateUserInfo: (info) => set({ userInfo: info }),
            logout: () => {
                // store 상태 초기화
                set({
                    memberTokens: '',
                    userInfo: {},
                    isExq: false,
                    refreshingToken: false,
                    isSnsLogin: false,
                    joinVerificationInfo: {
                        ci: '',
                        di: '',
                        username: '',
                        mem_phone: '',
                        memberKind: '',
                        gender: '',
                        birthdate: ''
                    }
                });
            
                // 세션스토리지 제거
                sessionStorage.removeItem('user-storage');
                
                // 로컬스토리지 제거
                localStorage.clear();
                
                // 쿠키 제거
                document.cookie.split(";").forEach(function(c) { 
                    document.cookie = c.replace(/^ +/, "")
                        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
                });
            },
            refreshMemberToken: async () => {
                // 이미 갱신 중이라면 바로 반환
                if (get().refreshingToken) return;

                set({ refreshingToken: true });

                try {
                    const response = await refreshToken();
                    if (response.data.code === 200) {
                        // 새로운 토큰 업데이트
                        get().updateTokens(response.data.data.access_token);
                    }
                } catch (error) {
                    console.error('토큰 갱신 오류:', error);
                } finally {
                    // 갱신 완료 후 플래그 초기화
                    set({ refreshingToken: false });
                }
            },
        }),
        {
            name: 'user-storage',
        }
    )
);

export default useUserStore;

